import { ApolloClient, InMemoryCache, HttpLink, from } from "@apollo/client";

export default new ApolloClient({
	cache: new InMemoryCache(),
	link: from([new HttpLink({ uri: environment.NETWORK_GATEWAY_CLIENT })]),
});
